import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ngMessages from 'angular-messages';
import forgotPasswordComponent from './forgot-password.component';

let forgotPasswordModule = angular.module('forgot-password', [
    uiRouter,
    ngMessages
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
    $stateProvider
    .state('forgot-password', {
        url: '/forgot-password',
        component: 'forgotPassword',
        data: {
            permissions: {
                except: ['AUTHORIZED'],
                redirectTo: 'home'
            }
        }
    });
})
.component('forgotPassword', forgotPasswordComponent)
.name;

export default forgotPasswordModule;
